import { IconBuildCache } from '@bitrise/bitkit-v2';

import { BuildDetailsTabId } from '@/enums/BuildDetailsTabs';
import { BuildCacheInfo, optimalCacheHitRateLimit } from '@/models/BuildCacheInfo';
import { formatPercent } from '@/utils/commonFormats';
import { buildDetailsPagePath } from '@/utils/monolithApiRouteService';

import RunnableMeta from './RunnableMeta';

const CacheMeta = ({
  appSlug,
  buildCacheInfo,
  buildSlug,
  showHint,
}: {
  appSlug: string;
  buildCacheInfo?: BuildCacheInfo;
  buildSlug: string;
  showHint: boolean;
}) => {
  if (!buildCacheInfo || !buildCacheInfo.anyInvocationForWorkflow) {
    return null;
  }

  const isBaselineBenchmark = !!buildCacheInfo.hasBaselineInvocation;

  let percentage;
  if (buildCacheInfo.usesCache) {
    percentage = buildCacheInfo.cacheHitRate;
  }

  const data = percentage !== undefined && percentage !== null ? formatPercent(percentage) : 'N/A';

  const hasWarning =
    showHint &&
    !isBaselineBenchmark &&
    (percentage === undefined || (percentage !== null && percentage < optimalCacheHitRateLimit));

  return (
    <RunnableMeta
      icon={IconBuildCache}
      data={data}
      defaultTooltipLabel="Cache hit rate"
      status={hasWarning ? 'warning' : undefined}
      definitionButton={{
        href: buildDetailsPagePath(appSlug, buildSlug, BuildDetailsTabId.buildCache),
        label: buildCacheInfo.usesCache || isBaselineBenchmark ? 'Optimize performance' : 'Restore connection',
      }}
      definitionText={
        hasWarning ? `Cache hit rate: ${data}.${buildCacheInfo.usesCache ? '' : ' No cache connection.'}` : undefined
      }
    />
  );
};

export default CacheMeta;
